import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe accepts property name and search.
 * Filters elements which have properties matching pattern created.
 * Example:
 *   <div *ngFor="let item of (items | RegexPipe: 'name' : searchTerm)"></div>
 */
@Pipe({
  name: 'RegexPipe',
  standalone: false
})
export class RegexPipe implements PipeTransform {
  transform(inputArray: any[], property: string, regexp: string, regexpOptions = 'i') {
    if (!regexp || !property) {
      return inputArray;
    }

    const reg = new RegExp(regexp.trim(), regexpOptions);
    return inputArray.filter(item => reg.test(item[property]));
  }
}
